module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "start-xs h-100 overflow-y-scroll"
  }, [_c('div', {
    staticClass: "pl-subheading tc ma4 assessment-title"
  }, [_vm._v("\n    Verbal Discussion Assessment\n  ")]), _vm._v(" "), _c('button', {
    staticClass: "exit-page ma2 absolute top-0 right-0 flex justify-center",
    class: {
      'shadow-1': _vm.hovered
    },
    staticStyle: {
      "margin": "30px"
    },
    on: {
      "click": _vm.closePage,
      "mouseenter": function($event) {
        _vm.hovered = true
      },
      "mouseleave": function($event) {
        _vm.hovered = false
      }
    }
  }, [_c('img', {
    staticClass: "dib h3 w3",
    staticStyle: {
      "max-width": "20px",
      "vertical-align": "middle"
    },
    attrs: {
      "src": "/static/close.svg",
      "alt": "close"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "absolute italics",
    staticStyle: {
      "bottom": "-35px"
    }
  }, [_vm._v("esc")])]), _vm._v(" "), _c('div', {
    staticClass: "pl-subheading mt5"
  }, [_c('span', {
    staticClass: "fw6"
  }, [_vm._v("Assessment")]), _vm._v(" "), _c('i', {
    directives: [{
      name: "my-tooltip",
      rawName: "v-my-tooltip",
      value: (_vm.assessment_description),
      expression: "assessment_description"
    }],
    staticClass: "fa fa-info-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "radio-button-container"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "10px 10px 10px 0px"
    }
  }, [_c('pl-radio', {
    attrs: {
      "value": false
    },
    model: {
      value: (_vm.assessment_status),
      callback: function($$v) {
        _vm.assessment_status = $$v
      },
      expression: "assessment_status"
    }
  }), _vm._v(" "), _c('span', [_vm._v("No Assessment")])], 1), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "10px 10px 10px 0px"
    }
  }, [_c('pl-radio', {
    attrs: {
      "value": true
    },
    model: {
      value: (_vm.assessment_status),
      callback: function($$v) {
        _vm.assessment_status = $$v
      },
      expression: "assessment_status"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Teacher can provide assessent with points")])], 1)]), _vm._v(" "), (_vm.assessment_status) ? _c('div', [_c('div', [_c('div', {
    staticClass: "pl-subheading mt4 flex items-center"
  }, [_c('span', {
    staticClass: "fw6"
  }, [_vm._v("Criteria Scale")]), _vm._v(" "), _c('toggle-button', {
    staticClass: "mh3",
    attrs: {
      "value": !!_vm.getCurrentDiscussion.point_cap,
      "color": "#72ccd7",
      "labels": false
    },
    on: {
      "change": _vm.toggleCriteriaScale
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "my-tooltip",
      rawName: "v-my-tooltip",
      value: (_vm.scale_description),
      expression: "scale_description"
    }],
    staticClass: "fa fa-info-circle",
    staticStyle: {
      "font-size": "12px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })], 1), _vm._v(" "), (_vm.point_scale !== null) ? _c('div', {
    staticClass: "mt3",
    staticStyle: {
      "margin-left": "6px"
    }
  }, [_c('pl-button', {
    staticClass: "pl-icon",
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "disabled": Number(_vm.point_scale) === 0
    },
    nativeOn: {
      "click": function($event) {
        _vm.point_scale -= 1
      }
    }
  }, [_c('i', {
    staticClass: "chevron clickable fa fa-chevron-left"
  })]), _vm._v(" "), _c('pl-input', {
    staticStyle: {
      "width": "50px",
      "height": "23px",
      "text-align": "center",
      "display": "inline-block"
    },
    attrs: {
      "centeredText": true,
      "error": _vm.point_scale === ''
    },
    on: {
      "input": _vm.inputed
    },
    model: {
      value: (_vm.point_scale),
      callback: function($$v) {
        _vm.point_scale = $$v
      },
      expression: "point_scale"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.point_scale) + "\n        ")]), _vm._v(" "), _c('pl-button', {
    staticClass: "pl-icon",
    staticStyle: {
      "display": "inline-block"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addPoint.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "chevron clickable fa fa-chevron-right"
  })])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "points-list-container mv4"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.available_point_types), function(point_type, index) {
    return _c('div', {
      key: (index + "-" + (point_type.title)),
      staticClass: "individual-point-selection flex clickable selected-description"
    }, [_c('pl-checkbox', {
      staticClass: "col-xs-1",
      attrs: {
        "value": point_type.tag
      },
      model: {
        value: (_vm.selected_points),
        callback: function($$v) {
          _vm.selected_points = $$v
        },
        expression: "selected_points"
      }
    }), _vm._v(" "), _c('strong', {
      staticClass: "col-xs-3"
    }, [_vm._v(" " + _vm._s(point_type.title) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-7"
    }, [_vm._v("\n          " + _vm._s(_vm.formatPointDescription(point_type)) + "\n        ")]), _vm._v(" "), (point_type.is_custom) ? _c('div', {
      staticClass: "clickable col-xs-1"
    }, [_c('pl-menu', {
      attrs: {
        "menuSize": 2,
        "direction": "right"
      }
    }, [_c('pl-button', {
      staticClass: "pl-icon",
      staticStyle: {
        "margin": "0"
      },
      attrs: {
        "slot": "menu_trigger"
      },
      slot: "menu_trigger"
    }, [_c('i', {
      staticClass: "fas fa-ellipsis-v"
    })]), _vm._v(" "), _c('ul', {
      attrs: {
        "menu-content": ""
      }
    }, [_c('li', {
      on: {
        "click": function($event) {
          return _vm.showPointCreationModal(point_type)
        }
      }
    }, [_c('span', [_vm._v("Edit")])]), _vm._v(" "), _c('li', {
      on: {
        "click": function($event) {
          return _vm.deletePoint(point_type)
        }
      }
    }, [_c('span', [_vm._v("Delete")])])])], 1)], 1) : _vm._e()], 1)
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "new-point-button clickable flex justify-center items-center ripple",
    on: {
      "click": function($event) {
        _vm.show_point_creation_modal = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Create Assessment Point\n    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sticky-button-row flex items-center justify-between"
  }, [_c('span', {
    staticClass: "col-xs-8"
  }, [(_vm.assessment_status) ? _c('span', [_c('span', [_vm._v("\n          You have Selected " + _vm._s(_vm.selected_points.length) + " assessment types\n        ")])]) : _vm._e()]), _vm._v(" "), (_vm.have_points_changed) ? _c('pl-button', {
    staticClass: "pl-primary",
    nativeOn: {
      "click": function($event) {
        return _vm.updateAssessmentInformation.apply(null, arguments)
      }
    }
  }, [_vm._v("\n      Save Changes\n    ")]) : _c('pl-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v(" Close ")])], 1), _vm._v(" "), (_vm.show_point_creation_modal) ? _c('create-new-point-modal', {
    attrs: {
      "activityType": "live",
      "rts": _vm.discussions_with_point,
      "tag": _vm.tag
    },
    on: {
      "close": _vm.closePointModal
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_delete_point_modal) ? _c('dialog-delete-confirm', {
    attrs: {
      "optionalText": "Are you sure you want to delete this Point?"
    },
    on: {
      "close": function($event) {
        _vm.show_delete_point_modal = false
      },
      "actionConfirmed": _vm.deleteAssessmentPoint
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_alert_assessment_changing) ? [_c('pl-dialog', {
    staticClass: "center-xs",
    attrs: {
      "maxWidth": '600px',
      "padding": '2em'
    }
  }, [_c('div', {
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "0"
    }
  }, [_c('pl-button', {
    staticStyle: {
      "min-width": "0"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeAssessmentChangingAlert.apply(null, arguments)
      }
    }
  }, [_c('strong', {
    staticClass: "f4"
  }, [_vm._v("X")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "header pv3"
  }, [_c('span', {
    staticClass: "pl-secondary b",
    staticStyle: {
      "font-size": "24px"
    }
  }, [_vm._v("\n          Heads up!\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "ph3",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('p', [_vm._v("\n          Changing (or deleting) this assessment criteria for this RoundTable\n          will change (or delete) it for all of the other RoundTables in this\n          course that also use this criteria:\n        ")]), _vm._v(" "), _c('ul', _vm._l((_vm.displayCriteriaLds), function(discussion) {
    return _c('li', {
      key: discussion.id,
      staticClass: "b"
    }, [_vm._v("\n            " + _vm._s(discussion.title) + "\n          ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "pv2"
  }, [_c('pl-button', {
    staticClass: "pl-primary",
    staticStyle: {
      "font-size": "16px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeAssessmentChangingAlert.apply(null, arguments)
      }
    }
  }, [_vm._v("\n          Okay, Got it.\n        ")])], 1)])] : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pl-subheading"
  }, [_c('span', {
    staticClass: "fw6"
  }, [_vm._v("Criteria")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-192a9f2a!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/liveDiscussion/components/editAssessmentPointsLD.vue
// module id = 1735
// module chunks = 61